import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getInvestmentByAccountType = createAsyncThunk(
  "investment/getInvestmentByAccountType",
  async ({clientId, accountId, securityId } = {}, { rejectWithValue }) => {
    try {
      let queryParams = [];

      if (accountId) queryParams.push(`accountId=${accountId}`);
      if (securityId) queryParams.push(`securityId=${securityId}`);
        if (clientId) queryParams.push(`clientId=${clientId}`);
      const queryString = queryParams.length
        ? `?${queryParams.join("&")}`
        : "";

      const response = await getMethod(
        `/account/getInvestmentByAccountType${queryString}`
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Failed to fetch investments");
      }

      return data; // expected data.data
    } catch (error) {
      return rejectWithValue(
        error?.message || "Error fetching Investment By Account Type"
      );
    }
  }
);


const initialState = {
  investmentsByAccount: [],   
  loading: false,
  error: null,
  success: false,
};

const investmentByAccountTypeSlice = createSlice({
  name: "investmentByAccountType",
  initialState,
  reducers: {
    clearInvestmentByAccountState: (state) => {
      state.investmentsByAccount = [];
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getInvestmentByAccountType.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })

      .addCase(getInvestmentByAccountType.fulfilled, (state, action) => {
        state.loading = false;
        state.investmentsByAccount = action.payload?.rows || [];
        state.success = true;
      })

      .addCase(getInvestmentByAccountType.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to fetch investments for account type";
        state.success = false;
      });
  },
});

export const { clearInvestmentByAccountState } =
  investmentByAccountTypeSlice.actions;

export default investmentByAccountTypeSlice.reducer;
